import { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';

const formGroupRowStyleMixin = /*#__PURE__*/css(["padding:0;font-weight:initial;max-width:none;display:inline-flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:center;align-items:center;> *{margin-right:", ";margin-inline-end:", ";:last-child{margin-right:", ";margin-inline-end:", ";}}", ""], ({
  theme
}) => theme.form.input.internalElementInlineSpacing, ({
  theme
}) => theme.form.input.internalElementInlineSpacing, ({
  inline,
  theme
}) => inline ? theme.spacing.micro : '0', ({
  inline,
  theme
}) => inline ? theme.spacing.micro : '0', isMobile(css(["", ";margin-right:0;margin-inline-end:0;:last-child{margin-right:0;margin-inline-end:0;}"], ({
  theme
}) => theme.typography.mobile.base)));
var formGroupRowStyleMixin$1 = formGroupRowStyleMixin;

export { formGroupRowStyleMixin$1 as f };
//# sourceMappingURL=formGroupRowStyleMixin-b43c108e.js.map
